module.exports = __webpack_public_path__ + "media/images/store_btn-86f5e548db22e76b5672593d24bba49c.gif";